export default __webpack_public_path__ + "static/media/logo03.db1a15c4.svg";